import React from 'react';
import clsx from 'clsx';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TicketList from '../TicketList/TicketList';
import TicketDetailsPage from '../../TicketDetails/TicketDetailsPage';
import WagonDetailsPage from '../../WagonDetailsPage/WagonDetailsPage';
import WagonAvailabilityPage from '../../WagonAvailabilityPage/WagonAvailabilityPage';
import WagonSimulationPage from '../../WagonSimulationPage/WagonSimulationPage';
import MaintenanceStatusPage from '../../MaintenanceStatusPage/MaintenanceStatusPage';
import { loadingState } from './ContentTabsSlice';
import EditTicketPage from '../../EditTicket/EditTicketPage';
import ActionListPage from '../../ActionList/ActionListPage';
import ActionCreationPage from '../../ActionCreation/ActionCreationPage';
import AddInvoicePage from '../../AddInvoicePage/AddInvoicePage';
import InvoicesResearchPage from '../../InvoicesResearch/InvoicesResearch';
import WorkshopTimePage from '../../WorkshopTimePage/WorkshopTimePage';
import TotalCostOfOwnership from '../../TotalCostOfOwnershipPage/TotalCostOfOwnershipPage';
import MonitoringPage from '../../Monitoring/MonitoringPage';
import useStyles from './styles';
import RevisionParametersPage from '../../RevisionParameters/RevisionParametersPage';
import PlannedPredictionPage from '../../PlannedPrediction/PlannedPredictionPage';
import RevisionPlanUploadPage from '../../RevisionPlanUpload/RevisionPlanUploadPage';
import ParameterArPage from '../../ParameterAR/ParameterArPage';
import BusinessNeedPage from '../../BusinessNeed/BusinessNeedPage';
import ParametersScrapingPage from '../../ParametersScraping/ParametersScrapingPage';
import DurationParameterPage from '../../DurationParameter/DurationParameterPage';
import GcuDamageCodePage from '../../GcuDamageCode/GcuDamageCodePage';
import ContactsEmailPage from '../../ContactsEmail/ContactsEmailPage';
import ActualWorkshopsPage from '../../ActualWorkshops/ActualWorkshopsPage';

export default function ContentTabs(props) {
  const classes = useStyles();
  const { drawerOpened } = props;
  const loading = useSelector(loadingState);
  const isHomePage = useLocation().pathname === '/';
  const isTicketDetailsPage =
    useLocation().pathname.startsWith('/ticket/details');
  const isCreateTicketPage =
    useLocation().pathname.startsWith('/ticket/creation');
  const isEditTicketPage = useLocation().pathname.startsWith('/ticket/edit');
  const isActionListPage = useLocation().pathname.startsWith('/action/list');
  const isActionCreationPage =
    useLocation().pathname.startsWith('/action/creation');
  const isWagonSearchOrDetailsPage =
    useLocation().pathname.startsWith('/wagon');
  const isAddInvoicePage = useLocation().pathname.startsWith('/invoices/add');
  const isInvoicesResearchPage =
    useLocation().pathname.includes('/invoices/research');
  const isForecastPage = useLocation().pathname.startsWith(
    '/analytics/wagon-availability',
  );
  const isSimulationPage = useLocation().pathname.startsWith(
    '/analytics/wagon-simulation',
  );
  const isMaintennaceStatusPage = useLocation().pathname.startsWith(
    '/analytics/maintenance-status',
  );
  const isWorkshopTimePage = useLocation().pathname.startsWith(
    '/analytics/workshop-time',
  );
  const isTotalCostOfOwnershipPage = useLocation().pathname.startsWith(
    '/analytics/total-cost',
  );
  const isMonitoringPage = useLocation().pathname.startsWith(
    '/analytics/monitoring',
  );

  const isParametersRevisionPage = useLocation().pathname.includes(
    '/parameters/revision',
  );

  const isPlannedPredictionPage = useLocation().pathname.includes(
    '/revisionplan/plannedprediction',
  );

  const isRevisionPlanUploadPage = useLocation().pathname.includes(
    '/revisionplan/revisionPlanUpload',
  );
  const isParameterArPage = useLocation().pathname.includes(
    '/parameters/parameterAr',
  );

  const isBusinessNeedPage = useLocation().pathname.includes(
    '/parameters/businessNeed',
  );

  const isDurationParameterPage = useLocation().pathname.includes(
    '/parameters/durationParameter',
  );

  const isParametersScrapingPage = useLocation().pathname.includes(
    '/parameters/parametersScraping',
  );

  const isGcuDamageCodePage = useLocation().pathname.includes(
    '/parameters/gcuDamageCode',
  );

  const isContactsEmailPage = useLocation().pathname.includes(
    '/parameters/contactsEmail',
  );

  const isActualWorkshopsPage = useLocation().pathname.includes(
    '/parameters/actualWorkshops',
  );

  return (
    <div
      className={clsx(classes.tabPanel, {
        [classes.tabPanelShift]: drawerOpened,
      })}
    >
      {loading && (
        <Paper
          data-testid="loader"
          elevation={0}
          position="absolute"
          zindex="2"
          className={classes.loadingPaper}
        >
          <CircularProgress className={classes.loader} />
        </Paper>
      )}
      <Button onClick={() => window.showCollectorDialog()} />
      <Box position="relative" zindex="auto">
        <Paper elevation={0} className={classes.contentPaper}>
          {isHomePage && <TicketList />}
          {isTicketDetailsPage && <TicketDetailsPage />}
          {(isEditTicketPage || isCreateTicketPage) && <EditTicketPage />}
          {isActionListPage && <ActionListPage />}
          {isActionCreationPage && <ActionCreationPage />}
          {isWagonSearchOrDetailsPage && <WagonDetailsPage />}
          {isAddInvoicePage && <AddInvoicePage />}
          {isInvoicesResearchPage && <InvoicesResearchPage />}
          {isForecastPage && <WagonAvailabilityPage />}
          {isSimulationPage && <WagonSimulationPage />}
          {isMaintennaceStatusPage && <MaintenanceStatusPage />}
          {isWorkshopTimePage && <WorkshopTimePage />}
          {isTotalCostOfOwnershipPage && <TotalCostOfOwnership />}
          {isMonitoringPage && <MonitoringPage />}
          {isParametersRevisionPage && <RevisionParametersPage />}
          {isPlannedPredictionPage && <PlannedPredictionPage />}
          {isRevisionPlanUploadPage && <RevisionPlanUploadPage />}
          {isParameterArPage && <ParameterArPage />}
          {isBusinessNeedPage && <BusinessNeedPage />}
          {isDurationParameterPage && <DurationParameterPage />}
          {isParametersScrapingPage && <ParametersScrapingPage />}
          {isGcuDamageCodePage && <GcuDamageCodePage />}
          {isContactsEmailPage && <ContactsEmailPage />}
          {isActualWorkshopsPage && <ActualWorkshopsPage />}
        </Paper>
      </Box>
    </div>
  );
}
